/**
 * Vaporwave — retro neon. Magenta/purple on a deep indigo-to-violet gradient,
 * pink glow. Keeps the sci-fi spirit but trades cyan for an 80s synth palette.
 */
export const vaporwave = {
  id: 'vaporwave',
  name: 'Vaporwave',
  assignable: true,
  mantine: {
    primaryColor: 'grape',
    fontFamily: 'Rajdhani, sans-serif',
    headings: { fontFamily: 'Orbitron, sans-serif' },
  },
  cssVars: {
    '--bw-bg': 'radial-gradient(ellipse at 50% 15%, #2a1052 0%, #160a30 55%, #0a0518 100%)',
    '--bw-body-color': '#f3e6ff',
    '--bw-panel-bg': 'rgba(30, 14, 56, 0.92)',
    '--bw-panel-border': 'rgba(255, 92, 222, 0.18)',
    '--bw-accent': 'rgba(255, 92, 222, 1)',
    '--bw-glow-color': 'rgba(255, 92, 222, 0.35)',
    '--bw-glow-text-color': 'rgba(120, 220, 255, 0.5)',
    '--bw-body-font': "'Rajdhani', sans-serif",
    '--bw-heading-font': "'Orbitron', sans-serif",
    '--bw-heading-letter-spacing': '0.06em',
    '--bw-content-base': '1.125rem',
  },
}
